import { NgModule } from "@angular/core";

import { MultiSelectComponent } from "./multi-select.component";

@NgModule({
  imports: [MultiSelectComponent],
  exports: [MultiSelectComponent],
})
export class MultiSelectModule {}
